<template>
  <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="link_forward" transform="translate(-119.000000, -5.000000)" fill="currentColor">
              <g id="Actions-/-Navigation-/-arrow--left-/-16" transform="translate(118.000000, 4.000000)">
                  <path d="M14,4.5 L12.5,4.5 L12.5,1.5 L3.5,1.5 L3.5,4.5 L2,4.5 C1.44771525,4.5 1,4.94771525 1,5.5 L1,10.5 C1,11.0522847 1.44771525,11.5 2,11.5 L3.5,11.5 L3.5,14.5 L12.5,14.5 L12.5,11.5 L14,11.5 C14.5522847,11.5 15,11.0522847 15,10.5 L15,5.5 C15,4.94771525 14.5522847,4.5 14,4.5 Z M4.5,2.5 L11.5,2.5 L11.5,4.5 L4.5,4.5 L4.5,2.5 Z M11.5,13.5 L4.5,13.5 L4.5,8.5 L11.5,8.5 L11.5,13.5 Z M14,10.5 L12.5,10.5 L12.5,7.5 L3.5,7.5 L3.5,10.5 L2,10.5 L2,5.5 L14,5.5 L14,10.5 Z" id="Fill"></path>
              </g>
          </g>
      </g>
  </svg>
</template>

<script>
export default {
  name: 'Print'
};
</script>
